"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nodeType = exports.UiConfigSchema = exports.TaskSchema = void 0;
const finley_types_1 = require("@finley-technologies/finley-types");
const v4_1 = require("zod/v4");
exports.TaskSchema = v4_1.z.object({
    operation: v4_1.z.literal('sanitize'),
    srcArtifactSlug: v4_1.z.string(),
    baseFields: v4_1.z.array(finley_types_1.DataTapeField.BaseConfigSchema).describe(`
   * baseFields should be specified in the exact format
   * used in customer data tapes, not the standardized
   * post-sanitize format.
  `),
    delimiter: v4_1.z.string(),
    doNotSanitizeFieldNames: v4_1.z.boolean().optional().describe(`
   * this optional field will determine if the field
   * names in the output tape will be standardized
   * to snake_case. If this field is not set,
   * they will be snake_cased.
  `),
});
exports.UiConfigSchema = exports.TaskSchema.omit({
    srcArtifactSlug: true,
});
exports.nodeType = 'operation_sanitize';
//# sourceMappingURL=types.js.map